import angular from 'angular';
import { IEscalaFormDadosIniciais } from '../../models/escala.form.model';
import { calcularPrimeiraDataInicialPermitida, datasLimites } from '../../consts/dataslimites';
import { IConfiguracoesEscala, getConfiguracoesEscalaPadrao } from '../../models/escala.configuracoes.model';

export class MeurhEscalaDadosIniciaisFormController {

    static $inject = ['$scope', '$rootScope', '$state'];

    public form: angular.IFormController;
    public entity: IEscalaFormDadosIniciais;
    public configuracoesEscala: IConfiguracoesEscala = getConfiguracoesEscalaPadrao();
    public tipoEscalaRequired: boolean = true;
    public semDataFinal = false;

    public datasLimites = datasLimites;
    public primeiraDataInicialPermitida = this.getPrimeiraDataInicialPermitida();

    constructor (
		public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
        },
		public $state: angular.ui.IStateService,
	) {
        $scope.$watch('$ctrl.entity.selecionados', (newValue: any, oldValue: any): void => {
			if (newValue !== oldValue && this.entity.selecionados) {
				this.form.tipoescala.$setDirty();
				if (!this.temTipoEscalaSelecionado()) {
                    this.tipoEscalaRequired = true;
				} else {
                    this.tipoEscalaRequired = false;
				}
			}
		}, true);

        $scope.$watch('$ctrl.semDataFinal', (newValue?: boolean, oldValue?: boolean) => {
			if (newValue !== oldValue && newValue === true) {
                this.entity.datafinal = undefined;
                this.entity.selecionados.folga = false;
			}
		}, true);
    }

    $onInit(): void {
		this.entity.selecionados = {
            folga: false,
            lotacao: false,
            horario: false
        };
	}

    $onChanges(changes: angular.IOnChangesObject): void {
        if (changes.configuracoesEscala) {
            this.primeiraDataInicialPermitida = this.getPrimeiraDataInicialPermitida();
        }
    }

    private getPrimeiraDataInicialPermitida() {
        return calcularPrimeiraDataInicialPermitida(
            this.datasLimites.dataInicial,
            this.configuracoesEscala.USA_SLA_CALENDARIO,
            this.configuracoesEscala.FECHAMENTO_CALENDARIO,
            this.configuracoesEscala.CALENDARIO_FECHA_PROXIMO_MES
        );
    }

    private temTipoEscalaSelecionado(): boolean {
        let tipoEscalas: Array<boolean> = Object.values(this.entity.selecionados);
		return tipoEscalas.some((escala: boolean) => escala === true);
	}
}
